module.exports = __webpack_public_path__ + "static/media/features-bg-1.c2c4b1c0.svg";